export default {

    common_loading: 'Inapakia',
    common_cancel: 'Ghairi',
    common_confirm: 'Thibitisha',
    common_continue: 'Endelea',
    common_submit: 'Wasilisha',
    common_token_expire: 'Token imeisha, tafadhali ingia tena.',
    common_modify_success: 'Badiliko limefanikiwa',
    common_success: 'Imefanikiwa',

    common_home: 'Nyumbani',
    common_market: 'Soko',
    common_msgs: 'Ujumbe',
    common_find: 'Tafuta',
    common_me: 'Mimi',

    common_deposit: 'Weka',
    common_withdraw: 'Toa',
    common_team: 'TIMU',
    common_channel: 'CHANELI',
    common_service: 'HUDUMA',
    common_currency: 'SARAFU',
    common_more: 'ZAIDI',
    common_detail: 'MAELEZO',
    common_search: 'Tafuta',
    common_language: 'Lugha',
    common_share: 'Shiriki',
    common_logout: 'Ondoka',
    common_copy_success: 'Nakala imefanikiwa',
    common_send: 'Tuma',
    common_empty_data: 'Hakuna data',
    common_created: 'Imeundwa',
    common_time: 'Muda',

    toast_input_phone: 'Tafadhali ingiza nambari ya simu',
    toast_input_password: 'Tafadhali ingiza nenosiri',
    toast_input_full_name: 'Tafadhali ingiza jina kamili',
    toast_input_email: 'Tafadhali ingiza barua pepe',
    toast_input_refcode: 'Tafadhali ingiza msimbo wa rejea',
    toast_input_old_password: 'Tafadhali ingiza nenosiri la zamani',
    toast_input_new_password: 'Tafadhali ingiza nenosiri jipya',
    toast_input_repeat_password: 'Tafadhali ingiza nenosiri tena',
    toast_input_repeat_password_nosame: 'Manenosiri hayafanani',

    login_welcome: 'Karibu tena!',
    login_subtitle: 'INGIA KWA AKAUNTI YAKO',
    login_no_account: 'Huna akaunti?',
    register_title: 'Unda akaunti',
    register_subtitle: 'Tuanze na akaunti ya bure ya biashara ya quant',
    register_have_account: 'Tayari una akaunti?',
    
    user_phone: 'Nambari ya simu (9 Number)',
    user_password: 'Nenosiri',
    user_forget_password: 'Umesahau nenosiri?',
    user_sign_in: 'Ingia',
    user_sign_up: 'Jisajili',
    user_full_name: 'Jina kamili',
    user_email: 'Barua pepe',
    user_verife_code: 'Msimbo wa uthibitisho',
    user_ref_code: 'Msimbo wa rejea',
    user_old_password: 'Nenosiri la zamani',
    user_new_password: 'Nenosiri jipya',
    user_repeat_password: 'Rudia nenosiri',
    user_find_password: 'Tafuta Nenosiri Langu',
    user_modify_password: 'Badilisha Nenosiri Langu',
    user_modify_login_password: 'Badilisha nenosiri la kuingia',
    user_account_security: 'Usalama wa Akaunti',

    user_center: 'Kituo cha Mtumiaji',
    user_invite_reward_title: 'PATA BONASI YA ANGALAU 10%',
    user_invite_reward_desc: 'Wakaribisha marafiki kujiunga na kupata bonasi bila kikomo',
    user_invite_records: 'Rekodi ya tuzo ya mwaliko',
    user_security_protect: 'Linda usalama wa akaunti',

    user_kefu_title1: 'TUWASILIANE KUPITIA',
    user_kefu_title2: 'NJIA ZIFUATAZO',
    user_kefu_24hour_hint: 'Huduma ya wateja inayofanya kazi masaa 24',
    user_kefu_notice: 'Wakati mtumiaji aliyealikwa atakapofanya malipo, tuzo itaongezwa kiotomatiki kwenye salio lako la akaunti',
    user_invited: 'aliyealikwa',

    share_hint: 'Wakati mtumiaji aliyealikwa atakapofanya malipo, tuzo itaongezwa kiotomatiki kwenye salio lako la akaunti',
    share_copy_link: 'Nakili kiungo na ushiriki',
    share_rewards_record: 'Rekodi ya Tuzo',
    
    home_total_asset_value: 'THAMANI YA JUMLA YA MAALI',
    
    msg_msgs: 'Ujumbe',
    msg_contacts: 'Mawasiliano',

    wallet_balance: 'Salio',
    wallet_salary_balance: 'Salio la Mshahara',
    wallet_update_bank: 'Sasisha benki ya kutoa',
    wallet_account_settlement: 'Malipo ya Akaunti',
    wallet_payroll_records: 'Rekodi za Mshahara',
    wallet_financial_records: 'Rekodi za kifedha',
    wallet_trade_history: 'Historia ya Manunuzi',
    wallet_update_bank_info: 'SASISHA TAARIFA ZA BENKI',
    wallet_update_bank_hint: 'Akaunti sawa inaweza kufungwa kwa akaunti moja tu',
    wallet_update_bank_input_name: 'Tafadhali ingiza jina',
    wallet_update_bank_input_cardno: 'Akaunti ya Kuondoa Maombi (nambari)',
    wallet_update_bank_input_ifsc: 'Tafadhali ingiza SWIFT Code',
    wallet_update_bank_input_bankname: 'Tafadhali ingiza jina la benki',
    wallet_update_bank_input_otp: 'Tafadhali ingiza otp ya tawi',
    wallet_bind_bank_message: 'Sijafunga kadi yangu ya benki bado. Je, unataka kuifunga sasa?',
    wallet_bind_bank_go: 'nenda kufunga',

    deposit_recommend_amount: 'Kiasi kilichopendekezwa',
    deposit_select_channel_title: 'Tafadhali chagua njia ya kuchaji',

    withdraw_available_balance: 'Salio Lililopatikana',
    withdraw_amount: 'Kiasi',
    withdraw_taxs: 'Kodi',
    withdraw_total_amount: 'Jumla ya Kiasi',
    withdraw_select_bank: 'CHAGUA BENKI',
    withdraw_notice: 'Kutoa kodi 20%, muda wa kutoa Jumatatu hadi Ijumaa saa 7 asubuhi hadi 9 asubuhi, 2, Muda wa kutoa mshahara Jumatatu hadi Jumapili saa 7 asubuhi hadi 9 asubuhi',

    trade_ordering: 'Jozi za Biashara',
    trade_history: 'Historia',

    chat_message_deleted: 'Ujumbe huu umeondolewa',
    chat_message_empty: "Hakuna ujumbe",
    chat_conversation_started: 'Mazungumzo yalianzia:',
    chat_type_message: 'Chapa ujumbe',
    chat_reply: 'Jibu',

    channel_signal: 'CHANELI YA ISHARA',

    channel_signal: 'SIGNAL CHANNEL',

    team_level_1: 'Kiwango-1',  
    team_level_2: 'Kiwango-2',  
    team_level_3: 'Kiwango-3',  
    team_reg_num: 'Jumla ya waliosajiliwa',  
    team_recharge_num: 'Jumla ya waliofanya recharge',  
    team_recharged: 'Imechajiwa',  
    team_unrecharge: 'Haijachajiwa',  
    
    user_remember_password: 'Kumbuka nenosiri',  
    common_trade: 'Biashara',  
    common_time: 'Muda',  
    currency_name: 'Jina',  
    currency_latest_price: 'Bei ya hivi punde',  
    currency_rise_and_fall: 'Panda na Shuka',  
    trade_high_today: 'Kiwango cha juu cha leo',  
    trade_low_today: 'Kiwango cha chini cha leo',  
    trade_direction: 'Mwelekeo',  
    trade_buy_more: "CALL",  
    trade_buy_less: "PUT",  
    time_min: 'Dk',  
    time_hour: 'Sa',  
    time_day: 'Sk',  
    time_week: 'Wk',  
    time_mon: 'Mw',  
    
    follow_order_title: 'Fuata wafanyabiashara wa hali ya juu, pata faida',  
    follow_order_desc: 'Unaweza kuiga mikakati ya wafanyabiashara bora, kufuata agizo moja kwa moja, na kupata faida',  
    common_now_try: 'Jaribu sasa',  
    
    welfare_activity_title: 'Shughuli za hivi karibuni za ustawi',  
    welfare_activity_desc: 'Tafadhali fuatilia matukio ya ukurasa wa kwanza ili kujua sera yetu ya shughuli za hivi karibuni!',  
    appdownload: 'Pakua',  
    welfarecenter: 'Kituo cha Ustawi',

}